import ElementLineIndexer, {IndexedLineCollection} from "@/ts/base/Utils/ElementLineIndexer";
import debounce from "debounce";

export default class HeightEqualizer {
	static get FinishEvent() {
		return "height-equalized";
	}

	public elements: NodeListOf<HTMLElement>;
	protected timeout: number;
	protected refreshLimit: number = 100;

	constructor(elements: NodeListOf<HTMLElement>) {
		this.elements = elements;
		this.timeout = 0;

		if (this.elements.length > 0) {
			this.equalize()
				.then(() => {
					window.addEventListener("resize", debounce(this.onUpdate.bind(this), this.refreshLimit));
				});
		}
	}

	async equalize(): Promise<void> {

		this.collectRows()
			.then((result) => {
				const rows = result.rows;
				const maxLines = result.lineIndex;

				for (let i = 0; i < maxLines + 1; i++) {
					const row = rows[i];
					if (row.length > 1) {
						let max = 0;
						for (let i in row) {
							if (row.hasOwnProperty(i)) {
								let $item = row[i];
								let h = $item.offsetHeight;
								if (h > max) {
									max = h;
								}
							}
						}

						row.forEach($item => {
							$item.style.height = `${max}px`;
						});
					}
				}

				this.elements.forEach(item => {
					item.dispatchEvent(new Event(HeightEqualizer.FinishEvent));
				});
			});

	}

	async collectRows(): Promise<IndexedLineCollection> {
		const baseEls: HTMLElement[] = [];
		const indexer = new ElementLineIndexer();

		await this.resetHeights();

		indexer.setElements(this.elements);
		return indexer.index();
	}

	resetHeights(): Promise<void> {
		return new Promise(resolve => {
			window.setTimeout(() => {
				this.elements.forEach(
					(item, index) => {
						item.style.height = "";
					}
				);

				resolve();
			}, 10);
		})
	}

	protected async onUpdate(e: Event) {
		await this.equalize();
	}
}
